import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=3eea411f&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3eea411f')) {
      api.createRecord('3eea411f', component.options)
    } else {
      api.reload('3eea411f', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=3eea411f&", function () {
      api.rerender('3eea411f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2lviGwdVBc1RW/JS/childrenage.vue"
export default component.exports